import React from 'react';
import FilterPopover from '../ui/FilterPopover';
import IconButton from '../ui/IconButton';
import { useRole } from '../../hooks/useRole';
import { FILTER_OPTIONS } from '../../utils/inboxThreads';
import type { InboxFilter } from '../../types/Communications';
import { requestCompose, requestRsvpReminder, setInboxFilter, useInboxUi } from './inboxUiStore';

/**
 * The Communications controls in Header's breadcrumb bar: one Filters popover
 * (all / unread / note / vendor / guest / whatsapp), then icon buttons for
 * Compose and RSVP reminder (planners and above). Refresh is in the global header.
 */
const CommunicationsBar: React.FC = () => {
  const { canEdit } = useRole();
  const { filter } = useInboxUi();
  return (
    <>
      <FilterPopover
        selects={[{
          key: 'show',
          label: 'Show',
          options: FILTER_OPTIONS,
          value: filter,
          defaultValue: 'all',
          onChange: v => setInboxFilter(v as InboxFilter),
        }]}
      />
      {canEdit && <IconButton icon="plus" label="Compose" onClick={requestCompose} />}
      {canEdit && <IconButton icon="bell" label="RSVP reminder" onClick={requestRsvpReminder} />}
    </>
  );
};

export default CommunicationsBar;
